(function () {
    'use strict';
    angular.module('swif.framework')
    .service('FrameworkImportCSVService', FrameworkImportCSVService);

    function FrameworkImportCSVService (dataService, actionService, msgService, userService) {
        'ngInject';
        var service = {};

        service.extractOptions = extractOptions;
        service.doImport = doImport;
        service.preValidate = preValidate;

        function extractOptions (model) {
            var options = {
                encoding: model.encoding || '',
                separator: model.separator || '',
                quoting: model.quoting || '',
                headers: model.headers || false
            };
            return options;
        }

        function doImport (model) {
            var userContext = userService.getAuthenticatedUser().context;
            userContext.atomic_import = true;
            var options = service.extractOptions(model);
            var headers = model.mapping.filter(
                header => {
                    // empty string are already evaluated as 'false'
                    return header;
                }
            );
            return dataService.callKw(
                'import_csv',
                'do',
                [model.id, headers, options],
                {context: userContext}
            ).then(report => {
                var action = actionService.getActionById(model.contentType, 'misc', 'import_report', report);
                if (action) {
                    var options = {};
                    actionService.dispatch(model.contentType, action, report, options);
                }
                // Warning popup if openbase_importer returns at least one exception
                if (report.exceptions && report.exceptions.length > 0) {
                    var message = "L'import a rencontré une erreur. Veuillez vérifier que votre fichier correspond à l'un des formats suivants : OpenGST, TOTAL, LCC, Intermarché.";
                    msgService.addError({
                        code: 200,
                        type: 'danger',
                        data: {
                            fault_code: message
                        }
                    });
                }
                return true;
            });
        }

        function preValidate (data) {
            var importModel = data.model._import;
            if (!importModel) {
                return false;
            }
            return service.doImport(importModel);
        }

        return service;
    }


})();
